// src/components/Toolbar.jsx
import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../css/Toolbar.css';
import LogoutButton from './LogoutButton';

import {
  HiHome,
  HiCpuChip,
  HiAdjustmentsVertical,
  HiQuestionMarkCircle,
} from "react-icons/hi2";

export default function Toolbar({
  transparent = false,
  decor = 'wave',
}) {
  const [clock, setClock] = useState("");

const [dateStr, setDateStr] = useState("");
const [timeStr, setTimeStr] = useState("");
// ⬇ Toolbar.jsx 내부에 교체
useEffect(() => {
  const tick = () => {
    const now = new Date();

    // 날짜
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    setDateStr(`${yyyy}-${mm}-${dd}`);

    // 시간 (12시간제 + 오전/오후)
    let h = now.getHours();
    const ampm = h >= 12 ? "오후" : "오전";
    h = h % 12 || 12;
    const hh = String(h).padStart(2, "0");
    const mi = String(now.getMinutes()).padStart(2, "0");
    const ss = String(now.getSeconds()).padStart(2, "0");
    setTimeStr(`${ampm} ${hh}:${mi}:${ss}`);
  };

  tick();
  const id = setInterval(tick, 1000);
  return () => clearInterval(id);
}, []);

  const variantClass = transparent ? 'toolbar--transparent' : 'toolbar--solid';
  const decorClass = decor && decor !== 'none' ? `toolbar--decor-${decor}` : '';

  return (
    <header className={`toolbar ${variantClass} ${decorClass}`}>
      <nav className="toolbar__nav" aria-label="Global">

    <div className="toolbar-clock">
  <span className="clock-date">{dateStr}</span>
  <span className="clock-time">{timeStr}</span>
</div>

        {/* 중앙 로고 */}
        <span className="toolbar-logo toolbar-logo--center" title="홈으로 이동">
          레이제 피난유도기 관제시스템
        </span>

        {/* 오른쪽 아이콘 */}
        <div className="toolbar-right">
          <ul className="toolbar-icon-menu">
            <li><NavLink to="/" title="홈"><HiHome /></NavLink></li>
            <li><NavLink to="/locations" title="장비관리"><HiCpuChip /></NavLink></li>
            <li><NavLink to="/user" title="운영관리"><HiAdjustmentsVertical /></NavLink></li>
            <li>
              <a href="/manuals/manual.pdf" target="_blank" rel="noopener noreferrer" title="도움말">
                <HiQuestionMarkCircle />
              </a>
            </li>
            <li><LogoutButton iconOnly /></li>
          </ul>
        </div>

      </nav>
    </header>
  );
}
